import React, { useState } from "react";
import {
  Button,
  Card,
  CardTitle,
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import TeacherTable from "../../components/Tables/TeacherTable";
import StudentTable from "../../components/Tables/StudentTable";
import axios from "../../services/api/api";
import { GetClassByClassId } from "../../actions/teacherQueries";
import CreateTeacher from "../../components/Modal/CreateTeacherModal";
import AddTeachers from "../../components/Modal/AddTeachersToClass";
import AddStudents from "../../components/Modal/AddStudentsToClass";
import ImportStudentForm from "../../components/Forms/ImportStudentsForm";
import { toast } from "react-toastify";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import EditStudent from "../../components/Modal/EditStudent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { useLocation } from "react-router-dom";

function ClassOverview(props) {
  const intl = useIntl();
  const location = useLocation();
  const [teacherFilter, setTeacherFilter] = useState("");
  const [studentFilter, setStudentFilter] = useState("");
  const [allTeachers, setAllTeachers] = useState(location.state.teachers);
  const [teacherModal, setTeacherModal] = useState(false);
  const [studentModal, setStudentModal] = useState(false);
  const [imporStudentsModal, setImporStudentsModal] = useState(false);
  const [detachTeacherModal, setDetachTeacherModal] = useState(false);
  const [teacherToDetach, setTeacherToDetach] = useState({});
  const [teacherToUpdate, setTeacherToUpdate] = useState(null);
  const [createTeacherModal, setCreateTeacherModal] = useState(false);
  const [studentToUpdate, setStudentToUpdate] = useState(null);
  const [studentEditModal, setStudentEditModal] = useState(false);

  const classQuery = GetClassByClassId(location.state.class.id);

  if (classQuery.isPending) {
    return <Pacmanloader />;
  }

  const toggleStudentEditModal = (student) => {
    setStudentToUpdate(null);
    if (student && student.hasOwnProperty("email")) {
      setStudentToUpdate(student);
    }
    setStudentEditModal(!studentEditModal);
  };

  const reloadClass = () => {
    classQuery.refetch();
  };

  const getallTeachers = () => {
    axios
      .get(`/GetTeachersBySchoolId?schoolId=${location.state.schoolId}`)
      .then((res) => {
        setAllTeachers(res.data.result);
      });
  };

  const filterTeachers = (event) => {
    setTeacherFilter(event.target.value);
  };

  const toggleModals = (entity) => {
    if (entity === "teacher") {
      setTeacherModal(!teacherModal);
    } else if (entity === "studentImport") {
      setImporStudentsModal(!imporStudentsModal);
    } else {
      setStudentModal(!studentModal);
    }
  };

  const filterStudents = (event) => {
    setStudentFilter(event.target.value);
  };

  const toggleDetachTeacherModal = (teacher) => {
    setTeacherToDetach({ name: teacher.name, id: teacher.id });
    setDetachTeacherModal(true);
  };

  const toggleCreateTeacherModal = (teacher) => {
    setTeacherToUpdate(null);
    if (teacher) {
      getTeacher(teacher.id)
        .then((classes) => {
          teacher.classes = classes;
          setTeacherToUpdate(teacher);
          setCreateTeacherModal(!createTeacherModal);
          return;
        })
        .catch((err) => {
          setCreateTeacherModal(!createTeacherModal);
        });
    } else {
      setCreateTeacherModal(!createTeacherModal);
    }
  };

  const detachTeacher = () => {
    axios
      .post(
        `teacher/removefromclass?teacherid=${teacherToDetach.id}&classid=${classQuery.data.id}`
      )
      .then(() => {
        toast.success(
          <FormattedMessage id="TheTeacherHasBeenRemovedFromTheClass" />,
          TOAST_CONFIG
        );
        reloadClass();
        resetDetachTeacher();
      })
      .catch((err) => {
        toast.warn(
          intl.formatMessage(
            { id: "CouldNotDeleteTeacherTeacherName" },
            {
              teacher: err.response.data,
            }
          ),
          TOAST_CONFIG
        );
        resetDetachTeacher();
      });
  };

  const getTeacher = (id) => {
    return new Promise((resolve, reject) => {
      if (id) {
        axios.get(`/Teacher/${id}`).then((res) => {
          resolve(res.data.result.classes);
        });
      } else {
        reject("unable to fetch teacher info.");
      }
    });
  };

  const resetDetachTeacher = () => {
    setDetachTeacherModal(false);
    setTeacherToDetach({});
  };

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">{classQuery.data.name}</h5>
      </div>
      <Row>
        <Col sm="6">
          <Card body>
            <CardTitle>
              <FormattedMessage id="Teacher" />
            </CardTitle>
            <Row className="search-row">
              <Col className="col-6">
                <Input
                  className="search-input"
                  placeholder={intl.formatMessage({
                    id: "SearchTeacher",
                  })}
                  onChange={filterTeachers.bind(this)}
                />
              </Col>
              <Col className="offset-1 col-5">
                <Button
                  color="primary"
                  outline
                  className="float-end"
                  onClick={() => {
                    toggleModals("teacher");
                  }}
                >
                  <FontAwesomeIcon icon="plus" />
                </Button>
              </Col>
            </Row>
            <TeacherTable
              updateTeacher={toggleCreateTeacherModal}
              detachTeacher={toggleDetachTeacherModal}
              teachers={classQuery.data?.teachers || []}
              filter={teacherFilter}
              fullAccess={true}
            />
          </Card>
        </Col>
        <Col sm="6">
          <Card body>
            <CardTitle>
              <FormattedMessage id="Students" />
            </CardTitle>
            <Row className="search-row">
              <Col className="col-6">
                <Input
                  className="search-input"
                  placeholder={intl.formatMessage({
                    id: "SearchStudent",
                  })}
                  onChange={filterStudents.bind(this)}
                />
              </Col>
              <Col className="offset-1 col-5">
                <Button
                  color="primary"
                  outline
                  className="float-end"
                  onClick={() => toggleModals("studentImport")}
                >
                  <FontAwesomeIcon icon="upload" />{" "}
                  <FormattedMessage id="ImportStudents" />
                </Button>
              </Col>
            </Row>
            <StudentTable
              toggleEdit={toggleStudentEditModal}
              students={classQuery.data?.students || []}
              filter={studentFilter}
            />
          </Card>
        </Col>
      </Row>

      <AddTeachers
        classId={classQuery.data.id}
        isOpen={teacherModal}
        toggle={() => toggleModals("teacher")}
        teachers={allTeachers}
        existingTeachers={classQuery.data.teachers}
        loadTeachers={reloadClass}
        reloadAllTeachers={getallTeachers}
      />

      <AddStudents
        classId={classQuery.data.id}
        isOpen={studentModal}
        toggle={() => toggleModals("student")}
        students={location.state.students}
        loadStudents={reloadClass}
        existingStudents={classQuery.data.students}
      />

      <EditStudent
        toggle={toggleStudentEditModal.bind(this)}
        isOpen={studentEditModal}
        student={studentToUpdate}
        updateStudents={reloadClass}
        classes={location.state.schoolClasses}
      />

      <ConfirmDialog
        isOpen={detachTeacherModal}
        title={intl.formatMessage({
          id: "RemoveTeacherFromClass",
        })}
        message={
          <div>
            {intl.formatMessage(
              { id: "AreYouSureYouWantToDeleteTeacherNameFromClassName" },
              {
                teacherName: teacherToDetach.name,
                className: classQuery.data.name,
              }
            )}
          </div>
        }
        toggle={resetDetachTeacher}
        onProceed={detachTeacher}
        danger={true}
      />

      <Modal
        size="lg"
        isOpen={imporStudentsModal}
        toggle={() => toggleModals("studentImport")}
      >
        <ModalHeader toggle={() => toggleModals("studentImport")}>
          <FontAwesomeIcon icon="upload" />
          &nbsp; <FormattedMessage id="ImportStudents" />
        </ModalHeader>
        <ModalBody>
          <ImportStudentForm
            preSelectedClassId={classQuery.data.id}
            updateStudents={reloadClass}
            dismissModal={() => toggleModals("studentImport")}
            studentClasses={[classQuery.data]}
          />
        </ModalBody>
      </Modal>

      <CreateTeacher
        teacherToUpdate={teacherToUpdate}
        schoolClasses={location.state.schoolClasses}
        isOpen={createTeacherModal}
        toggle={toggleCreateTeacherModal}
        loadTeachers={reloadClass}
        fullAccess={true}
      />
    </div>
  );
}
export default ClassOverview;
